var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.06415 10.8311C2.60329 5.96644 6.46585 2.10401 11.3306 1.56507C11.602 2.32621 11.7497 3.14604 11.7497 4.00038C11.7497 8.00445 8.50381 11.2504 4.49975 11.2504C3.6453 11.2504 2.82538 11.1026 2.06415 10.8311ZM13.2497 4.00038C13.2497 3.13438 13.1239 2.29777 12.8896 1.50781C18.3785 1.70816 22.7922 6.12173 22.9926 11.6106C22.2026 11.3762 21.3659 11.2504 20.4997 11.2504C15.6673 11.2504 11.7497 15.1679 11.7497 20.0004C11.7497 20.8666 11.8756 21.7035 12.1101 22.4936C6.62085 22.2934 2.20697 17.8794 2.00684 12.3901C2.79689 12.6245 3.63362 12.7504 4.49975 12.7504C9.33224 12.7504 13.2497 8.83287 13.2497 4.00038ZM22.9354 13.1697C22.3965 18.0346 18.534 21.8973 13.6691 22.4363C13.3976 21.675 13.2497 20.855 13.2497 20.0004C13.2497 15.9963 16.4957 12.7504 20.4997 12.7504C21.3542 12.7504 22.1742 12.8982 22.9354 13.1697Z",
    fill: "#C497FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoll);
export default __webpack_public_path__ + "static/media/boll.d51328e037411bb06cdfca723ae56753.svg";
export { ForwardRef as ReactComponent };